import { MessageEvent } from 'reconnectingwebsocket';

import { config } from './config/config';
import {
  ServerSocketEvent,
  FetchAssociationTickerResponsePayload
} from '../../../ticker/shared/socket/events'
import {
  loadTickerStateFailure,
  loadAssociationTickerStateSuccess,
  matchUpdate,
  LoadAssociationTickerStatePayload,
  mapTickerMatchState,
  mapTickerMatchStates,
  mapTickerMatchDay,
} from './ticker-state/reducer';

import { TickerStore, associationReducer } from './index';
import { SimpleTickerMatchState, TickerType } from './models';
import { getToday } from './utils';
import { setActiveFilter } from './day-filter/reducer';
import { matchStatsUpdate } from './ticker-state/reducer';
import { TickerApiMatchState } from '../../shared/indoor/ticker';
import { buildSocketClient } from './socket';

export const connectToTicker = async (tickerId: string, store: TickerStore, teamId?: string) => {

  const onFetchAssociationTickerResponse = (payload: FetchAssociationTickerResponsePayload | null, tickerId: string) => {

    if (payload === null) {
      return store.dispatch(loadTickerStateFailure('No ticker data received for ticker instance: ' + tickerId))
    }

    const state: LoadAssociationTickerStatePayload = {
      matchDays: payload.matchDays.map(m => mapTickerMatchDay(m, payload.matchSeries)),
      matchSeries: payload.matchSeries,
      matchStates: mapTickerMatchStates(payload.matchStates),
      matchStats: payload.matchStats,
      settings: payload.settings
    }
    const rootState: ReturnType<typeof associationReducer> = store.getState() as any
    if (rootState.dayFilter.activeFilterDay === null) {
      const today = getToday()
      const todayIdx = payload.matchDays.findIndex(m =>
        new Date(m.date).toLocaleDateString() === today.toLocaleDateString())
      store.dispatch(setActiveFilter(todayIdx))
    }
    return store.dispatch(loadAssociationTickerStateSuccess(state))
  }

  try {
    const res = await fetch(`${config.httpEndpoint}/live/indoor/tickers/${tickerId}`)
    if (res.ok) {
      const payload: FetchAssociationTickerResponsePayload = await res.json()
      onFetchAssociationTickerResponse(payload, tickerId)
    } else {
      onFetchAssociationTickerResponse(null, tickerId)
    }
  } catch(error) {
    onFetchAssociationTickerResponse(null, tickerId)
  }

  const client = await buildSocketClient(tickerId, store, TickerType.INDOOR)

  const onMessage = (msg: MessageEvent) => {

    try {

      const event: ServerSocketEvent = JSON.parse(msg.data)

      switch (event.type) {
        case 'FETCH_DATA_RESPONSE_ERROR':
          const msg = event.payload.type === 'NOT_FOUND'
            ? `Es konnte kein Ticker mit der id ${tickerId} gefunden werden.`
            : `Bitte überprüfen Sie die tickerId: ${tickerId}`
          client.close()
          return store.dispatch(loadTickerStateFailure(msg))

        case 'MATCH_UPDATE':
          try {
            const matchstate = mapTickerMatchState(event.payload as SimpleTickerMatchState | TickerApiMatchState)
            return store.dispatch(matchUpdate(matchstate))
          } catch (error) {
            return
          }
        
        case 'MATCH_STATS_UPDATE':
          try {
            const matchstats = event.payload
            return store.dispatch(matchStatsUpdate(matchstats))
          } catch (error) {
            return
          }

        default:
          return null

      }

    } catch (err) {
      return store.dispatch(loadTickerStateFailure('Failed parsing ticker data for ticker instance: ' + tickerId))
    }
  }

  client.onmessage = onMessage

}
